var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOpenToJobIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6 3.433h-2.1v-1.4a1.4 1.4 0 00-1.4-1.4H4.9a1.4 1.4 0 00-1.4 1.4v1.4H1.4a1.4 1.4 0 00-1.4 1.4v7.7a1.4 1.4 0 001.4 1.4h11.2a1.4 1.4 0 001.4-1.4v-7.7a1.4 1.4 0 00-1.4-1.4zm-7.7-1.4h4.2v1.4H4.9v-1.4zm7.7 10.5H1.4V8.476h11.2v4.057zm0-5.626H1.4V4.833h11.2v2.074z",
    fill: "url(#openToJobIcon_svg__paint0_linear_9719_90695)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "openToJobIcon_svg__paint0_linear_9719_90695",
    x1: 7.824,
    y1: 25.611,
    x2: 18.959,
    y2: 20.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#01D6B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#218FEE"
  })))));
}

export default SvgOpenToJobIcon;